import { OrderDataFusionSummary } from "../../../dispatch/src/OrderDataFusionSummary";
import { StopProgress } from "../../../dispatch/src/StopProgress";
import { CityState, DataSource, HorizontalSpacer, Image, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutBillingHistoryOverview extends Layout {
    citystateCustomer: CityState;
    horizontalspacer1: HorizontalSpacer;
    imageComments: Image;
    imageDatafusionCustomer: Image;
    imageSummaryInvoice: Image;
    imageYSplit: Image;
    label4: Label;
    labelAddress1: Label;
    labelAddress2: Label;
    labelBridgeCustomer: Label;
    labelContactEmail: Label;
    labelContactPhone: Label;
    labelEquipmentTypeId: Label;
    labelOrderValueCaption: Label;
    labelReferenceNumbers: Label;
    labelTempDelim: Label;
    labelTempMax: Label;
    labelTempMin: Label;
    labelTemperatureRange: Label;
    labelTrackingRequired: Label;
    labelTrailerType: Label;
    labelWeightCaption: Label;
    layoutOrderDataFusionSummary: OrderDataFusionSummary;
    layoutStopProgress: StopProgress;
    panel15: Panel;
    panel2: Panel;
    panel3: Panel;
    panel4: Panel;
    panel5: Panel;
    panel6: Panel;
    panel8: Panel;
    panelCommodity: Panel;
    panelDataFusion: Panel;
    panelDelivered: Panel;
    panelIcons: Panel;
    panelOrderInfo: Panel;
    panelOrderValue: Panel;
    panelRefNbrs: Panel;
    panelTempRange: Panel;
    panelWeight: Panel;
    sourceBillingComments: DataSource;
    sourceBillingHistory: DataSource;
    sourceCalculateOverridePay: DataSource;
    sourceCustomer: DataSource;
    sourceDataFusionOrderSummary: DataSource;
    sourceDistanceAlert: DataSource;
    sourceOrders: DataSource;
    textboxBillingDate: Textbox;
    textboxBillingUser: Textbox;
    textboxBolDate: Textbox;
    textboxCommodity: Textbox;
    textboxContactName: Textbox;
    textboxInvoiceNbr: Textbox;
    textboxInvoiceRecvDate: Textbox;
    textboxName: Textbox;
    textboxOrderValue: Textbox;
    textboxSalespersonId: Textbox;
    textboxTransferDate: Textbox;
    textboxWeight: Textbox;
}
